module.exports = __webpack_public_path__ + "img/145.42b2e1fa.jpg";